import { AppointmentTypes } from '../../utilities/constants';
import { hasInProgressTransfer, TransferStatus } from '../../utilities/transferStatusBuilder';
import type { Car, CarLocation, CarStatus } from '../../../../types/car';

const mapVehicleToCar = (transferStatus: TransferStatus) => {
    const { vehicle, status } = transferStatus;
    if (!vehicle) return null;

    const carLocation: CarLocation = {
        storeName: vehicle.storeName,
        stateAbbreviation: vehicle.stateAbbreviation,
        transferText: status && buildTransferText(transferStatus),
        minEstimatedTransferDurationInDays: vehicle.minEstimatedTransferDurationInDays,
        maxEstimatedTransferDurationInDays: vehicle.maxEstimatedTransferDurationInDays,
    };

    const statusInfo: CarStatus = {
        isReserved: vehicle.isReserved,
        isComingSoon: vehicle.isComingSoon,
        hasPriceDrop: vehicle.hasPriceDrop,
        isShipping: status ? hasInProgressTransfer({ vehicle, status }) : false,
    };

    const car: Car = {
        stockNumber: vehicle.stockNumber.toString(),
        year: vehicle.year,
        make: vehicle.make,
        model: vehicle.model,
        trim: vehicle.trim,
        price: vehicle.basePrice,
        originalPrice: vehicle.originalPrice,
        mileage: vehicle.mileage,
        distance: 0, // todo - location this
        engineType: vehicle.engineType,
        location: carLocation,
        statusInfo: statusInfo,
    };

    return car;
};

const buildTransferText = ({ appointmentTime, appointmentType }: TransferStatus) => {
    const isTestDrive = appointmentType?.includes(AppointmentTypes.TEST_DRIVE);
    if (appointmentTime && isTestDrive) {
        const appointmentDate = new Date(appointmentTime);
        const appointmentTimeFormatted = `${appointmentDate.getMonth() + 1}/${appointmentDate.getDate()}`;
        return `Test drive appointment for ${appointmentTimeFormatted}`;
    }
    // Todo : add Customer Transfer API to source the actual delivery date
    return 'Arriving soon';
};

export default mapVehicleToCar;
